import { Component } from '@angular/core';

import { BaseDynamicFieldComponent } from '../field-components/base-dynamic-field.component';
import { MultilineField } from '../fields/multiline-field';

/**
 * Component to generate a dynamic form component for multi-line text fields
 */
@Component({
  selector: 'ng-xform-multiline-field',
  template: `
    <ng-xform-form-control-layout [fieldComponent]="instance">
    <textarea [attr.rows]="field.rows" id="{{elementId}}" class="form-control" [formControl]="control"></textarea>
    </ng-xform-form-control-layout>
  `,
})
export class MultilineFieldComponent extends BaseDynamicFieldComponent<MultilineField> {}
